import { lazy, Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './contexts/AuthContext'
import { getDefaultRouteForRole } from './config/accessControl'
import { getVariantHomeRoute, isAdminApp, isCampoApp } from './config/appVariant'
import { LoadingScreen } from './components/Spinner'

const LoginPage = lazy(() => import('./pages/LoginPage'))
const SelecaoOperadoraPage = lazy(() => import('./pages/SelecaoOperadoraPage'))
const CampoOperadoraPage = lazy(() => import('./pages/CampoOperadoraPage'))
const PainelPage = lazy(() => import('./pages/PainelPage'))
const CampoPage = lazy(() => import('./pages/CampoPage'))
const SprayCardPage = lazy(() => import('./pages/SprayCardPage'))

function Protegida({ children }: { children: React.ReactNode }) {
  const { session, loading } = useAuth()
  if (loading) return <LoadingScreen />
  if (!session) return <Navigate to="/login" replace />
  return <>{children}</>
}

function ComOperadora({ children }: { children: React.ReactNode }) {
  const { session, operadora, loading } = useAuth()
  if (loading) return <LoadingScreen />
  if (!session) return <Navigate to="/login" replace />
  if (!operadora) return <Navigate to="/operadoras" replace />
  return <>{children}</>
}

function getHomeRoute(params: {
  session: unknown
  operadora: unknown
  papel: string | null
}) {
  if (!params.session) return '/login'
  if (!params.operadora) return '/operadoras'
  if (isCampoApp()) return '/campo'
  if (isAdminApp()) return '/painel'
  return getDefaultRouteForRole(params.papel)
}

export default function App() {
  const { session, operadora, papel, loading } = useAuth()

  if (loading) return <LoadingScreen />

  const homeRoute = getHomeRoute({ session, operadora, papel })

  return (
    <Suspense fallback={<LoadingScreen />}>
      <Routes>
        <Route path="/login" element={session ? <Navigate to={homeRoute} replace /> : <LoginPage />} />

        <Route
          path="/operadoras"
          element={
            <Protegida>
              {isCampoApp() ? <CampoOperadoraPage /> : <SelecaoOperadoraPage />}
            </Protegida>
          }
        />

        {!isCampoApp() && (
          <Route path="/painel/*" element={<ComOperadora><PainelPage /></ComOperadora>} />
        )}

        {!isAdminApp() && (
          <Route path="/campo" element={<ComOperadora><CampoPage /></ComOperadora>} />
        )}

        <Route path="/spray-card" element={<SprayCardPage />} />
        <Route path="/dashboard" element={<Navigate to="/painel" replace />} />
        <Route path="/" element={<Navigate to={homeRoute || getVariantHomeRoute()} replace />} />
        <Route path="*" element={<Navigate to={homeRoute || getVariantHomeRoute()} replace />} />
      </Routes>
    </Suspense>
  )
}
